module.exports = __webpack_public_path__ + "static/img/6150_phase_function_Paper_Points.bbbefc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6150_phase_function_Paper_Points.png
// module id = D/CD
// module chunks = 0